import { combineDataProviders, Identifier } from 'react-admin';
import { pgrestDataProvider } from './pgrestDataProvider';
import quickbooksDataProvider from './quickbooksDataProvider';
import { addSearchMethod } from '@react-admin/ra-search';
// import partnersDataProvider from '../dataProvider/partners';
// import attachmentsDataProvider from '../components/AttachmentsDataProvider';


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeEmptyStrings = (data: any) => {
  const cleaned = data;
  for (const [key, value] of Object.entries(data)) {
    if (value === '') {
      cleaned[key] = null;
    }
  }
  delete cleaned.files;
  return cleaned;
};


const dataProviders = combineDataProviders((resource) => {
  switch (resource) {
    case 'contracts':
    case 'clients':
    case 'categories':
    case 'funerals':
    case 'directors':
    case 'sb_invoices':
    case 'sb_payments':
    case 'sb_creditmemos':
    case 'funeral_clients':
    case 'marital_statuses':
    case 'chapels':
    case 'cemeteries':
    case 'cause_of_deaths':
    case 'family_rooms':
    case 'places':
    case 'clergy':
    case 'funeral_clergy':
    case 'coroners':
    case 'funeral_coroners':
    case 'profiles':
    case 'images':
    case 'search_clients':
    case 'events':
    case 'comments':
    case 'subscriptions':
    case 'settings':
    case 'sendgrid_events':
    case 'articles':
    case 'quotes':
    case 'quote_contacts':
    case 'leads':
    case 'attachments':
    case 'partners':
    case 'customer_events':
    case 'funeral_feed':
    case 'review_requests':
    case 'aftercare':
    case 'communications':
    case 'notes':
    case 'form_audit_log':
    case 'agent_runs':
    case 'agent_tasks':
    case 'inbox_items':
    case 'inbox_dismissals':
      return pgrestDataProvider;
    
    // Analytics views (exposed via PostgREST)
    case 'analytics.weekly_funnel':
    case 'analytics.weekly_leads':
    case 'analytics.campaign_performance':
    case 'analytics.conversion_funnel':
    case 'analytics.daily_lead_metrics':
    case 'analytics.call_sessions_with_ads':
    case 'analytics.lead_response':
    case 'analytics.leads_with_calls':
    case 'analytics.weekly_lead_qualification':
    case 'analytics.disqualification_reasons':
    case 'analytics.qualification_funnel':
    case 'analytics.daily_qualification_metrics':
    case 'analytics.qualified_followups':
      return pgrestDataProvider;

    // case 'attachments':
    //   return attachmentsDataProvider;

    case 'invoices':
    case 'items':
    case 'taxes':
    case 'accounts':
    case 'payments':
    case 'paymentmethods':
    case 'creditmemos':
    case 'customers':
      return quickbooksDataProvider;
    default:
      throw new Error(`Unknown resource: ${resource}`);
  }
});


const dataProvidersWithSearch = addSearchMethod(dataProviders, {
  funerals: {
      label: (record:any) =>
        `${record.name} (${record.funeralid})`,
      description: (record:any) =>
          `${record.address}-${record.email}`,
  }
});


export default dataProvidersWithSearch;
